// extracted by mini-css-extract-plugin
module.exports = {"brandTrendingWrap":"eu-z"};